export const getTopColorClass = ({ userType, rebate, publicacion }) => {
    if (userType.isAdminMod && rebate.idAdminAprueba === 0) {
        return "top-color-rojo";
    }
    if (publicacion.tieneRebate) {
        return "top-color-verde";
    }
    return "card w-auto";
}
